module.exports = __webpack_public_path__ + "static/img/banner3.73d49a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/home/banner3.png
// module id = ICVY
// module chunks = 2